import SEAD_NXT_LOGO from "assets/svg/NCFE_logo.svg";
import { PageNotFound } from "layouts/not-found";
import { Navigate, Route, Routes } from "react-router-dom";
import routes from "routes";

export default function Auth() {
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "ltr";
  return (
    <>
      <div className="flex  min-h-[100vh]">
        <div className=" flex min-h-[100%] min-w-[45%] items-center justify-center	rounded-br-[9.375rem] bg-[#E5F6FF]">
          <img src={SEAD_NXT_LOGO} alt="logo" className="w-[30rem]" />
        </div>
        <div className="min-w-[55%]">
          <Routes>
            {getRoutes(routes)}
            <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    </>
  );
}
